import React from 'react';
import {FormattedMessage} from "react-intl";

import Grid from "@mui/material/Grid";

import FormikInput from "components/input/new/FormikInput";

import {greyishBlue500} from "assets/jss/main";

// The delivery promise shown at checkout, pushed to Sylius.
function DeliveryDurationFields(props) {
    return (
        <Grid item container columnSpacing={2} rowSpacing={1}>
            <Grid item xs={6}>
                <FormikInput
                    name={'minimumEstimatedDeliveryDuration'}
                    label={'shippingMethods.form.field.minimumEstimatedDeliveryDuration.label'}
                    placeholder={'shippingMethods.form.field.minimumEstimatedDeliveryDuration.placeholder'}
                />
            </Grid>
            <Grid item xs={6}>
                <FormikInput
                    name={'maximumEstimatedDeliveryDuration'}
                    label={'shippingMethods.form.field.maximumEstimatedDeliveryDuration.label'}
                    placeholder={'shippingMethods.form.field.maximumEstimatedDeliveryDuration.placeholder'}
                />
            </Grid>
            <Grid item xs={12}>
                <span style={{fontSize: '12px', color: greyishBlue500}}>
                    <FormattedMessage id={'shippingMethods.form.field.estimatedDeliveryDuration.help'}/>
                </span>
            </Grid>
        </Grid>
    );
}

export default DeliveryDurationFields;
